module.exports = __webpack_public_path__ + "market/static/img/luckdraw_bg_1.2d2a3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/luckdraw_bg_1.png
// module id = HydI
// module chunks = 1